/** @jsx jsx */
import { jsx } from 'theme-ui';
import { createContext, useRef, useCallback, useContext, useState, useEffect, } from 'react';
import { without } from 'lodash';
export var ResultContext = createContext(function () { return function () { }; });
export var ResultProvider = function (_a) {
    var children = _a.children;
    var listeners = useRef([]);
    var context = useCallback(function (pathnameOrListener, result) {
        if (typeof pathnameOrListener === 'string') {
            listeners.current.forEach(function (listener) {
                listener(pathnameOrListener, result);
            });
        }
        else {
            listeners.current.push(pathnameOrListener);
            return function () {
                listeners.current = without(listeners.current, pathnameOrListener);
            };
        }
    }, []);
    return (jsx(ResultContext.Provider, { value: context }, children));
};
export function useResultContext() {
    return useContext(ResultContext);
}
export function useSubscribeToResult(pathname, onChange) {
    var subscribe = useResultContext();
    var callbackRef = useRef(onChange);
    callbackRef.current = onChange;
    useEffect(function () {
        return subscribe(function (_pathname, result) {
            if (_pathname === pathname) {
                callbackRef.current(result);
            }
        });
    }, [pathname, subscribe]);
}
export function useResult(pathname) {
    var _a = useState(), result = _a[0], setResult = _a[1];
    useSubscribeToResult(pathname, setResult);
    return result;
}
export function useSetResult(pathname) {
    var emit = useResultContext();
    return useCallback(function (result) {
        emit(pathname, result);
    }, [emit, pathname]);
}
//# sourceMappingURL=ResultContext.js.map